import { apiSlice } from './apiSlice';
export const categoriesApi = apiSlice.injectEndpoints({ endpoints: builder => ({
  getCategories: builder.query({ query: (scope) => scope === 'available' ? '/api/categories/available' : '/api/categories', providesTags: (result, error, scope) => scope === 'available' ? ['Products', 'Product'] : [], keepUnusedDataFor: 60 }),
}) });
export const { useGetCategoriesQuery } = categoriesApi;
